angular.module('auth')
    .service('eventCodeFilter',function($resource,$http,BASE_PATH){
        return  $resource(BASE_PATH.API_URL+'groups/:group_id/events/:event_code', { group_id:'@group_id',event_code:'@event_code'});
    });
